import { mapValues } from 'lodash/fp'

export default (object: object) => (data?: any): any =>
  mapValues((value: (data?: any) => any) => value(data), object)
